export const exerciseCmsHelperText = "Settings for Exercises featured in Coa's web-app.";
